<template>
  <div id="app">
    <Main />
  </div>
</template>

<script>
import Main from './views/Main'

export default {
  components: {
    Main
  }
}
</script>

<style lang="scss">
@import url("assets/styles/slds-fca.css");

#app {
  display: flex;
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  justify-content: stretch;
  flex-direction: row;
}

/*** Global animations ***/
/** fade **/
.fade-enter {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-out;
}

.fade-leave-to {
  opacity: 0;
}

/** slide-fade-right **/
.slide-fade-right-enter {
  transform: translateX(-20px);
  opacity: 0;
}

.slide-fade-right-enter-active,
.slide-fade-right-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-right-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

/** slide-fade-right-delay **/
.slide-fade-right-delay-enter {
  transform: translateX(-20px);
  opacity: 0;
}

.slide-fade-right-delay-enter-active,
.slide-fade-right-delay-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-right-delay-enter-active {
  transition-delay: .3s;
}

.slide-fade-right-delay-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

/** slide-fade-left-delay **/
.slide-fade-left-delay-enter {
  transform: translateX(20px);
  opacity: 0;
}

.slide-fade-left-delay-enter-active,
.slide-fade-left-delay-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-left-delay-enter-active {
  transition-delay: .3s;
}

.slide-fade-left-delay-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}

/** slide-fade-left **/
.slide-fade-left-enter {
  transform: translateX(20px);
  opacity: 0;
}

.slide-fade-left-enter-active,
.slide-fade-left-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-left-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}

/** slide-fade-down **/
.slide-fade-down-enter {
  transform: translateY(-10px);
  opacity: 0;
}

.slide-fade-down-enter-active,
.slide-fade-down-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-down-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

/** slide-fade-up **/
.slide-fade-up-enter {
  transform: translateY(10px);
  opacity: 0;
}

.slide-fade-up-enter-active,
.slide-fade-up-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-up-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

/** flip **/
.flip-enter {
  transform: rotateY(0deg);
  opacity: 0;
}

.flip-enter-active,
.flip-leave-active {
  transition: all 0.3s ease;
}

.flip-leave-to {
  transform: rotateY(180deg);
  opacity: 0;
}
</style>
